import { useCallback } from 'react';

const useSearch = (searchConfig) => {
  const searchItems = useCallback((searchTerm, items) => {
    if (!searchTerm || searchTerm.length < searchConfig.minMatchLength) {
      return items;
    }

    const searchTerms = searchTerm
      .split(/\s+/)
      .filter(term => term.length >= searchConfig.minMatchLength)
      .map(term => term.toLowerCase());

    if (searchTerms.length === 0) {
      return items;
    }

    return items.filter(item => {
      return searchTerms.every(searchTerm => {
        return searchConfig.fields.some(field => {
          // Gestion des objets
          if (field.type === 'object' && field.searchFields) {
            const objectValue = item[field.key];
            if (!objectValue) return false;

            return field.searchFields.some(searchField => {
              const value = objectValue[searchField];
              if (!value) return false;
              return String(value).toLowerCase().includes(searchTerm);
            });
          }

          // Gestion des champs simples
          const value = item[field.key];
          if (!value) return false;

          const fieldValue = String(value).toLowerCase();

          switch (field.type) {
            case 'number':
              return String(value) === searchTerm;
            case 'currency':
              const numericValue = String(value).replace(/[^0-9.]/g, '');
              return numericValue === searchTerm;
            default:
              return fieldValue.includes(searchTerm);
          }
        });
      });
    });
  }, [searchConfig]);

  return { searchItems };
};

export default useSearch; 